import { Component, OnInit, forwardRef } from '@angular/core';
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  ActionSheetController,
  AlertController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GrupoGerenciarParticipantesAddPage } from '../grupo-gerenciar-participantes-add/grupo-gerenciar-participantes-add.page';
import { GrupoMotivoDesligamentoPage } from '../grupo-motivo-desligamento/grupo-motivo-desligamento.page';
import { GrupoTransferirParticipantesPage } from '../grupo-transferir-participantes/grupo-transferir-participantes.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImagePipe } from 'src/app/pipes/image/image';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';

@Component({
  selector: 'app-grupo-gerenciar-participantes',
  templateUrl: './grupo-gerenciar-participantes.page.html',
  styleUrls: ['./grupo-gerenciar-participantes.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent,
  ],
})
export class GrupoGerenciarParticipantesPage implements OnInit {
  participantes: any = [];
  idGrupo: string;
  tipo;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    public userProvider: UserProvider
  ) {
    this.participantes = this.navParams.get('participantes');
    this.idGrupo = this.navParams.get('idGrupo');
    this.tipo = this.navParams.get('tipo');
  }
  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss(this.participantes);
  }

  async addParticipantes() {
    var data = { idGrupo: this.idGrupo, tipo: this.tipo };
    const modalPage = await this.modalCtrl.create({
      component: GrupoGerenciarParticipantesAddPage,
      componentProps: data,
    });
    modalPage.present();

    const pessoa = await modalPage.onWillDismiss();
    if (pessoa.data) {
      this.participantes = pessoa.data;
    }
  }

  async removerParticipante(participante: { nome: string; id: string }) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Confirma Exclusão?'),
      message: this.translate.instant('Excluir') + ' ' + participante.nome,
      buttons: [
        {
          text: this.translate.instant('Não'),
        },
        {
          text: this.translate.instant('Sim'),
          handler: () => {
            this.grupoProvider
              .removerParticipante(this.idGrupo, participante.id)
              .subscribe(() => {
                this.participantes.splice(
                  this.participantes.indexOf(participante),
                  1
                );
              });
          },
        },
      ],
    });
    alert.present();
  }

  async detalhes(participante: any) {
    const buttons = [];

    if (this.userProvider.hasConfig(123)) {
      buttons.push({
        text: this.translate.instant('Editar'),
        handler: async () => {
          const modal = await this.modalCtrl.create({
            component: GrupoGerenciarParticipantesAddPage,
            componentProps: {
              idGrupo: this.idGrupo,
              participante: participante,
              tipo: this.tipo,
            },
          });

          modal.onDidDismiss().then((result) => {
            if (result.data) {
              this.participantes = result.data;
            }
          });

          await modal.present();
        },
      });
    }

    if (this.userProvider.hasConfig(124)) {
      buttons.push({
        text: this.translate.instant('Remover'),
        handler: () => {
          this.removerParticipante(participante);
        },
      });
    }

    if (this.userProvider.hasConfig(165)) {
      buttons.push({
        text: this.translate.instant('Solicitação de desligamento'),
        handler: async () => {
          const modal = await this.modalCtrl.create({
            component: GrupoMotivoDesligamentoPage,
            componentProps: {
              idGrupo: this.idGrupo,
              participante: participante,
              tipo: this.tipo,
            },
          });
          await modal.present();
        },
      });
    }

    if (this.userProvider.hasConfig(166)) {
      buttons.push({
        text: this.translate.instant('Transferência de Participante'),
        handler: async () => {
          const modal = await this.modalCtrl.create({
            component: GrupoTransferirParticipantesPage,
            componentProps: {
              idGrupo: this.idGrupo,
              participante: participante,
              tipo: this.tipo,
            },
          });

          modal.onDidDismiss().then((result) => {
            if (result.data) {
              this.participantes.splice(
                this.participantes.indexOf(participante),
                1
              );
            }
          });

          await modal.present();
        },
      });
    }

    buttons.push({
      text: this.translate.instant('Fechar'),
      role: 'destructive',
    });

    if (buttons.length > 0) {
      const actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('Opções'),
        buttons,
      });

      await actionSheet.present();
    }
  }
}
